"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKiotaVersion = getKiotaVersion;
const rpc = __importStar(require("vscode-jsonrpc/node"));
const connect_1 = __importDefault(require("../connect"));
/**
 * Retrieves the version of Kiota by connecting to the Kiota service.
 *
 * @returns {Promise<string | undefined>} A promise that resolves to the Kiota version string if available, otherwise undefined.
 * @throws {Error} If an error occurs while connecting to the Kiota service or retrieving the version.
 */
async function getKiotaVersion() {
    const result = await (0, connect_1.default)(async (connection) => {
        const request = new rpc.RequestType0("GetVersion");
        return await connection.sendRequest(request);
    });
    if (result instanceof Error) {
        throw result;
    }
    if (result) {
        const version = result.split("+")[0];
        if (version) {
            return version;
        }
    }
    return undefined;
}
;
//# sourceMappingURL=getKiotaVersion.js.map